// Central place for the brand colours of the app.
// Change "accent" here once the official brand colour is known - everything else follows.
export default {
  // Elegant, slightly muted salmon used for highlights, active states and primary actions
  accent: '#e4806a',
  // Warm light grey page background that lets the white cards stand out
  background: '#f6f4f1',
  // Status colours: closed is deliberately neutral, it is not an error
  closed: '#757575',
  open: '#2e9d5b'
}
